
import { Component, Vue, Watch } from 'vue-property-decorator';

import { Debounce } from 'vue-debounce-decorator';

import CPTooltipAdvanced from '@/components/globals/CPTooltipAdvanced.vue';
import CPLoader from '@/components/globals/CPLoader.vue';
import { ProductType } from '@/types/productType';

@Component({
  components: {
    CPLoader,
    CPTooltipAdvanced,
  },
})
export default class CPBasketBuy extends Vue {

  public grandTotal: number | string = 0;
  public unitAmount: number = 0;
  public cashAmount: number = 0;
  public holdingsPercentage: number = 0;
  public availableCashPercentage: number = 0;

  public loading: boolean = false;

  public activeInput: string = 'Units';

  public tradeOptions: string = 'Units';

  @Watch('unitAmount')
  public updateUnits() {
    if (this.activeInput === 'Units') {
      this.updateVals();
    }
  }

  @Watch('cashAmount')
  public updateCashAmount2() {
    if (this.activeInput === 'Amount') {
      this.updateCashAmount();
    }
  }

  @Watch('holdingsPercentage')
  public updateHoldingsPercentage2() {
    if (this.activeInput === 'PrcentageHoldings') {
      this.updateHoldingsPercentage();
    }
  }
  @Watch('availableCashPercentage')
  public updatePercentageOfCash2() {
    if (this.activeInput === 'PrcentagePortfolio') {
      this.updatePercentageOfCash();
    }
  }
  @Watch('isEdit')
  public updateEditAmount() {
    this.unitAmount = this.editDetails.TradeValue;
  }

  public get consultantReferenceCurrency() {
    return this.$store.state.consultantDefaultCurrency;
  }

  get consultantClientList() {
    return this.$store.state.account.details.consultantClientList;
  }

  public getComputedConsultantCurrencyValue(value: any): any {
    const EURValue: any =
      value *
      this.findCurrencyRate(this.consultantReferenceCurrency?.Currency)
        .Rate_EUR;
    const newVal: any = (EURValue * 1) / this.accountReferenceCurrency.Rate_EUR;
    return newVal.toFixed(2);
  }

  public get activeAccountSummary() {
    return this.$store.state.account.details.activeAccount;
  }
  public get accountReferenceCurrency() {
    return this.$store.state.referenceCurrency;
  }

  public get productDetails() {
    return this.$store.state.baskets.buy.details;
  }

  public get activelyManagedCertificates() {
    return this.$store.state.products.activelyManagedCertificates;
  }

  public get hasNoNAV(): boolean {
    const nav = this.productDetails.NAV;
    const movNav = this.productDetails.MovNav;
    return !nav && !movNav;
  }

  public get unitsLabel(): string {
    const p = this.productDetails;
    if (p.ProductType === ProductType.AMC) { return 'Nominal'; }
    return p.Denomination && p.Denomination !== 0 ? 'Nominal (divisible by ' + p.Denomination + ')' : 'Units';
  }

  public get minimumCashBalance() {
    return this.activeAccountSummary.MinCashBalance;
  }
  public get availableCash() {
    return this.activeAccountSummary.AvailableBalance;
  }
  public get accountCurrency() {
    return this.activeAccountSummary.currency;
  }

  public get isEdit() {
    return this.$store.state.baskets.buy.edit;
  }

  public get editDetails() {
    return this.$store.state.baskets.buy.editDetails;
  }

  public get cart() {
    return this.$store.state.baskets.cart.items;
  }

  public get displayAvailableCashPercentage() {
    if (isNaN(this.availableCashPercentage) || !isFinite(this.availableCashPercentage)) {
      return 0;
    }
    return this.availableCashPercentage;
  }

  public set displayAvailableCashPercentage(newVal) {
    this.availableCashPercentage = newVal;
  }

  public get displayHoldingsPercentage() {
    if (isNaN(this.holdingsPercentage) || !isFinite(this.holdingsPercentage)) {
      return 0;
    }
    return this.holdingsPercentage;
  }

  public set displayHoldingsPercentage(newVal) {
    this.holdingsPercentage = newVal;
  }

  public changeActiveCategory(category: string) {
    if (category === 'Units') {
      this.tradeOptions = 'Units';
    } else {
      this.tradeOptions = 'Amount';
    }
    this.activeInput = category;
  }

  public roundToTwo(num: number) {
    return +(Math.round(parseFloat(num + 'e+2')) + 'e-2');
  }

  public convertCurrencyToAny(incomingAmount: number, incomingRate: number, outgoingRate: number) {
    return this.roundToTwo((incomingAmount * incomingRate) / outgoingRate);
  }

  // function to find currency object from string based list.
  public findCurrencyRate(currency: any) {
    const updatedRefObj = this.$store.state.currencyRates.filter((x: any) => {
      return x.Currency === currency;
    });
    return updatedRefObj[0];
  }

  @Debounce(500)
  public updateVals() {

    if (this.productDetails.ProductType === 'Hybrid, Structured Instruments') {
      this.grandTotal = this.unitAmount;
      this.cashAmount = this.unitAmount;
      if (parseFloat(this.activeAccountSummary.securityPosition) > 0) {
        this.holdingsPercentage = this.convertCurrencyToAny(
          ((this.unitAmount / this.activeAccountSummary.securityPosition) * 100),
          this.findCurrencyRate(this.productDetails.Currency).Rate_EUR,
          this.findCurrencyRate(this.accountCurrency).Rate_EUR);
      } else {
        this.holdingsPercentage = 0;
      }
      this.availableCashPercentage = parseFloat(
        this.convertCurrencyToAny(this.unitAmount / this.availableCash * 100,
          this.findCurrencyRate(this.productDetails.Currency).Rate_EUR,
          this.findCurrencyRate(this.accountCurrency).Rate_EUR).toFixed(5),
      );

      //      // this.unitAmount*100 / this.availableCash*100
    } else if (this.productDetails.ProductType === 'Fixed Income Bond') {
      this.grandTotal = this.unitAmount;
      this.cashAmount = this.unitAmount;
      if (parseFloat(this.activeAccountSummary.securityPosition) > 0) {
        this.holdingsPercentage = parseFloat(
          this.convertCurrencyToAny(
            ((this.unitAmount / this.activeAccountSummary.securityPosition) * 100),
            this.findCurrencyRate(this.productDetails.Currency).Rate_EUR,
            this.findCurrencyRate(this.accountCurrency).Rate_EUR).toFixed(5),
        );
      } else {
        this.holdingsPercentage = 0;
      }
      this.availableCashPercentage = parseFloat(
        this.convertCurrencyToAny((
          ((this.unitAmount) /
            parseFloat(this.availableCash)) *
          100),
          this.findCurrencyRate(this.productDetails.Currency).Rate_EUR,
          this.findCurrencyRate(this.accountCurrency).Rate_EUR).toFixed(5),
      );
    } else if (!this.productDetails.NAV) {

      // The OfferPrice is given as a percentage value,
      // so to get the value, multiply the Units by the OfferPrice and divide by 100
      this.grandTotal = parseFloat((this.unitAmount * this.productDetails.OfferPrice / 100).toFixed(2));
      this.cashAmount = this.unitAmount * this.productDetails.OfferPrice / 100;
      if (parseFloat(this.activeAccountSummary.securityPosition) > 0) {
        this.holdingsPercentage = parseFloat(
          (
            ((this.unitAmount * (this.productDetails.OfferPrice / 100)) /
              this.activeAccountSummary.securityPosition) *
            100
          ).toFixed(5),
        );
      } else {
        this.holdingsPercentage = 0;
      }
      this.availableCashPercentage = parseFloat(
        (
          ((this.unitAmount * (this.productDetails.OfferPrice / 100)) /
            parseInt(this.availableCash, 10)) *
          100
        ).toFixed(5),
      );

    } else {
      this.grandTotal = parseFloat((this.unitAmount * this.productDetails.NAV).toFixed(2));
      this.cashAmount = this.unitAmount * this.productDetails.NAV;
      if (parseFloat(this.activeAccountSummary.securityPosition) > 0) {
        this.holdingsPercentage = parseFloat(
          this.convertCurrencyToAny((
            ((this.unitAmount * this.productDetails.NAV) /
              this.activeAccountSummary.securityPosition) *
            100),
            this.findCurrencyRate(this.productDetails.Currency).Rate_EUR,
            this.findCurrencyRate(this.accountCurrency).Rate_EUR).toFixed(5),
        );
      } else {
        this.holdingsPercentage = 0;
      }
      this.availableCashPercentage = parseFloat(
        this.convertCurrencyToAny((
          ((this.unitAmount * this.productDetails.NAV) /
            parseFloat(this.availableCash)) *
          100),
          this.findCurrencyRate(this.productDetails.Currency).Rate_EUR,
          this.findCurrencyRate(this.accountCurrency).Rate_EUR).toFixed(5),
      );
    }
  }

  @Debounce(500)
  public updateCashAmount() {
    if (this.hasNoNAV) {
      this.grandTotal = parseFloat(parseFloat(String(this.cashAmount)).toFixed(2));
      this.unitAmount = 0;
      this.holdingsPercentage = 0;
      this.availableCashPercentage = 0;
      return;
    }
    const unit = this.cashAmount / this.productDetails.NAV;
    this.unitAmount = parseFloat(unit.toFixed(5));
    // @ts-ignore - TODO
    this.grandTotal = parseFloat(parseFloat(this.cashAmount).toFixed(2));
    this.availableCashPercentage = this.convertCurrencyToAny(((unit * this.productDetails.NAV * 100) / (this.availableCash * 100)) * 100, this.findCurrencyRate(this.productDetails.Currency).Rate_EUR.toFixed(5),
      this.findCurrencyRate(this.accountCurrency).Rate_EUR);

    this.holdingsPercentage = parseFloat(
      this.convertCurrencyToAny(
        (((unit * this.productDetails.NAV) / (this.activeAccountSummary.securityPosition * 100)) * 100) * 100,
        this.findCurrencyRate(this.productDetails.Currency).Rate_EUR,
        this.findCurrencyRate(this.accountCurrency).Rate_EUR).toFixed(5),
    );
  }

  @Debounce(500)
  public updateHoldingsPercentage() {
    this.unitAmount = parseFloat(
      (
        ((this.holdingsPercentage / 100) *
          this.activeAccountSummary.securityPosition) / this.productDetails.NAV
      ).toFixed(5),
    );
    this.grandTotal = parseFloat(
      this.convertCurrencyToAny((this.unitAmount * this.productDetails.NAV),
        this.findCurrencyRate(this.accountCurrency).Rate_EUR,
        this.findCurrencyRate(this.productDetails.Currency).Rate_EUR).toFixed(2),
    );
    this.cashAmount = parseFloat(
      this.convertCurrencyToAny((this.unitAmount * this.productDetails.NAV),
        this.findCurrencyRate(this.accountCurrency).Rate_EUR,
        this.findCurrencyRate(this.productDetails.Currency).Rate_EUR).toFixed(5),
    );
    this.unitAmount = parseFloat((this.cashAmount / this.productDetails.NAV).toFixed(5));
    this.availableCashPercentage = parseFloat(
      this.convertCurrencyToAny((
        ((this.unitAmount * this.productDetails.NAV) /
          parseInt(this.availableCash, 10)) *
        100),
        this.findCurrencyRate(this.productDetails.Currency).Rate_EUR,
        this.findCurrencyRate(this.accountCurrency).Rate_EUR).toFixed(5),
    );
  }

  @Debounce(500)
  public updatePercentageOfCash() {
    this.unitAmount = parseFloat(
      (
        ((this.availableCashPercentage / 100) *
          parseInt(this.availableCash, 10)) / this.productDetails.NAV
      ).toFixed(5),
    );
    this.grandTotal = parseFloat(
      this.convertCurrencyToAny(
        (this.unitAmount * this.productDetails.NAV),
        this.findCurrencyRate(this.accountCurrency).Rate_EUR,
        this.findCurrencyRate(this.productDetails.Currency).Rate_EUR).toFixed(2),
    );
    this.cashAmount = parseFloat(
      this.convertCurrencyToAny(
        (this.unitAmount * this.productDetails.NAV),
        this.findCurrencyRate(this.accountCurrency).Rate_EUR,
        this.findCurrencyRate(this.productDetails.Currency).Rate_EUR).toFixed(5),
    );
    parseFloat((this.unitAmount * this.productDetails.NAV).toFixed(5));
    this.holdingsPercentage = parseFloat(
      (
        ((this.unitAmount * this.productDetails.NAV) /
          parseInt(this.activeAccountSummary.securityPosition, 10)) *
        100
      ).toFixed(5),
    );
    this.unitAmount = parseFloat((this.cashAmount / this.productDetails.NAV).toFixed(5));
  }

  public close() {
    this.$store.commit('toggleBuyBasket', false);
  }

  public getComputedCurrencyValue(value: any): any {
    value = value ?? 0;
    if (this.activeAccountSummary && this.activeAccountSummary.currency) {
      const EURValue: any =
        value *
        this.findCurrencyRate(this.activeAccountSummary.currency).Rate_EUR;
      const newVal: any =
        (EURValue * 1) / this.accountReferenceCurrency.Rate_EUR;
      return (newVal ?? 0).toFixed(2);
    }
  }

  public checkIfCanBuy() {
    if (this.hasNoNAV) {
      return !(this.cashAmount > 0);
    }
    if (this.checkDenomination() ||
      this.checkMinInvest() ||
      this.checkCouponUnitAmount() ||
      this.checkCoupon() ||
      this.checkProductTypeEquities() ||
      this.checkUnitAmount() ||
      this.checkGrandTotalAndAvailableCash()) {
      return true;
    }
    return false;
  }

  public checkDenomination() {
    const amount = this.productDetails.ProductType === ProductType.AMC ? this.cashAmount : this.unitAmount;
    return (this.productDetails.Denomination && amount % this.productDetails.Denomination !== 0);
  }

  public checkMinInvest() {
    const isAmc = this.productDetails.ProductType === ProductType.AMC;
    const amount = isAmc ? this.cashAmount : this.unitAmount;
    let minInvest = this.productDetails.MinInvest;
    if (minInvest == null && isAmc && this.activelyManagedCertificates) {
      const match = this.activelyManagedCertificates.find((a: any) => a.ISIN === this.productDetails.ISIN);
      minInvest = match?.MinInvest ?? null;
    }
    if (minInvest && amount < minInvest) {
      return true;
    }
    return !isAmc && minInvest != null && this.unitAmount % minInvest !== 0;
  }

  public checkCouponUnitAmount() {
    return ((this.productDetails.Coupon && this.unitAmount % 1000 !== 0));
  }

  public checkCoupon() {
    return ((this.productDetails.Coupon && this.unitAmount === 0) ? true : false);
  }

  public checkProductTypeEquities() {
    return (this.productDetails.ProductType === 'Equities' && !Number.isInteger(this.unitAmount));
  }

  public checkUnitAmount() {
    return (this.unitAmount < 1);
  }

  public checkGrandTotalAndAvailableCash() {
    return this.availableCashPercentage > 100 || this.availableCashPercentage <= 0 || isNaN(this.availableCashPercentage);
  }

  public async buy(isEdit: boolean) {
    if (this.productDetails.ProductType === 'Fixed Income Bond') {
      this.loading = true;
      let details: any = {
        TransactionType: 'Purchase',
        ProductType: 'Fixed Income Bond',
        ISIN: this.productDetails.ISIN,
        Coupon: this.productDetails.Coupon,
        FundName: this.productDetails.Coupon,
        Currency: this.productDetails.Currency,
        UserInfoId: parseFloat(this.$store.state.account.details.userId),
        CurrentUserBostonId: parseFloat(
          this.$store.state.account.details.bostonId,
        ),
        PlatformId: parseInt(
          this.$store.state.account.details.activeAccount.id,
          10,
        ),
        TradeOptions: 'Units',
        Units: this.tradeOptions === 'Units' ? this.unitAmount : '',
        Amount: this.tradeOptions === 'Amount' ? this.cashAmount : '',
      };
      if (isEdit) {
        details = {
          ID: this.editDetails.ID,
          TradeOptions: this.editDetails.TradeOptions,
          TradeValue: this.unitAmount,
        };
        await this.$store.dispatch('updateBasket', details);
      } else {
        await this.$store.dispatch('buyBasket', details);
      }
      this.loading = false;
    } else if (this.productDetails.ProductType === 'Hybrid, Structured Instruments' || this.productDetails.ProductType === 'Actively Managed Certificates') {
      const amount = this.productDetails.ProductType === ProductType.AMC ? this.cashAmount : this.unitAmount;
      const denominationCheck = !this.productDetails.Denomination || amount % this.productDetails.Denomination === 0;
      if (this.unitAmount > 0 && denominationCheck) {
        this.loading = true;
        let details: any = {
          TransactionType: 'Purchase',
          ProductType: this.productDetails.ProductType,
          ISIN: this.productDetails.ISIN,
          FundName: this.productDetails.FundName,
          Currency: this.productDetails.Currency,
          UserInfoId: parseFloat(this.$store.state.account.details.userId),
          CurrentUserBostonId: parseFloat(
            this.$store.state.account.details.bostonId,
          ),
          PlatformId: parseInt(
            this.$store.state.account.details.activeAccount.id,
            10,
          ),
          TradeOptions: 'Units',
          Units: this.unitAmount
        };
        if (isEdit) {
          details = {
            ID: this.editDetails.ID,
            TradeOptions: this.editDetails.TradeOptions,
            TradeValue: this.unitAmount,
          };
          await this.$store.dispatch('updateBasket', details);
        } else {
          await this.$store.dispatch('buyBasket', details);
        }
        this.loading = false;
      }
    } else if (this.hasNoNAV && this.cashAmount > 0) {
      this.loading = true;
      let details: any = {
        TransactionType: 'Purchase',
        ProductType: this.productDetails.ProductType,
        ISIN: this.productDetails.ISIN,
        FundName: this.productDetails.FundName,
        Currency: this.productDetails.Currency,
        UserInfoId: parseFloat(this.$store.state.account.details.userId),
        CurrentUserBostonId: parseFloat(
          this.$store.state.account.details.bostonId,
        ),
        PlatformId: parseInt(
          this.$store.state.account.details.activeAccount.id,
          10,
        ),
        TradeOptions: 'Amount',
        Units: '',
        Amount: this.cashAmount,
      };
      if (isEdit) {
        details = {
          ID: this.editDetails.ID,
          TradeOptions: 'Amount',
          TradeValue: this.cashAmount,
        };
        await this.$store.dispatch('updateBasket', details);
      } else {
        await this.$store.dispatch('buyBasket', details);
      }
      this.loading = false;
      this.$store.commit('toggleBuyBasket', false);
    } else if (this.unitAmount > 0) {
      this.loading = true;
      let details: any = {
        TransactionType: 'Purchase',
        ProductType: this.productDetails.ProductType,
        ISIN: this.productDetails.ISIN,
        FundName: this.productDetails.FundName,
        Currency: this.productDetails.Currency,
        UserInfoId: parseFloat(this.$store.state.account.details.userId),
        CurrentUserBostonId: parseFloat(
          this.$store.state.account.details.bostonId,
        ),
        PlatformId: parseInt(
          this.$store.state.account.details.activeAccount.id,
          10,
        ),
        TradeOptions: this.tradeOptions,
        Units: this.tradeOptions === 'Units' ? this.unitAmount : '',
        Amount: this.tradeOptions === 'Amount' ? this.cashAmount : '',
      };
      if (isEdit) {
        details = {
          ID: this.editDetails.ID,
          TradeOptions: this.tradeOptions,
          TradeValue: this.tradeOptions === 'Amount' ? this.cashAmount : this.unitAmount,
        };
        await this.$store.dispatch('updateBasket', details);
      } else {
        await this.$store.dispatch('buyBasket', details);
      }
      this.loading = false;
      this.$store.commit('toggleBuyBasket', false);
    }
  }

  @Watch('cart')
  public closeLoading() {
    this.loading = false;
  }

  public mounted() {
    if (this.isEdit) {
      if (this.editDetails.TradeOptions === 'Amount') {
        this.tradeOptions = 'Amount';
        this.activeInput = 'Amount';
        this.cashAmount = this.editDetails.TradeValue;
      } else {
        this.unitAmount = this.editDetails.TradeValue;
      }
    }
  }

  public beforeDestroy() {
    this.$store.commit('buyBasketEdit', false);
    this.$store.commit('buyBasketEditDetails', null);
    this.$store.commit('updateDocuments', null);
  }
}
